import { select } from '@ngneat/elf';
import { getAuditOfferFollowUpDataSource, getAuditsOfferActivitiesDataSource, getAuditsOfferFromProposalDataSource, getAuditsProposalDetailsDataSource } from './audit-offer-followUp.requests';
import { auditOfferFollowUpStore } from './audit-offer-followUp.store';

export class AuditOfferFollowUpQuery {
  store = auditOfferFollowUpStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  auditOfferFollowUp$ = getAuditOfferFollowUpDataSource.data$();
  activities$ = getAuditsOfferActivitiesDataSource.data$();

  auditProposalDetails$ = getAuditsProposalDetailsDataSource.data$();
  allAuditsOfferFromProposal$ = getAuditsOfferFromProposalDataSource.data$();

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const auditOfferFollowUpQuery = new AuditOfferFollowUpQuery();
